import project1 from "./imgProject/Soc.png";
import project2 from "./imgProject/Note.png";
import project3 from "./imgProject/Currency.png";

const projects = [
    {
        title: 'Social network',
        skills: 'React, Redux, Node.js, JS, CSS',
        img: project1,
        imgBig: project1,
        gitHubLink: '#'
    },

    {
        title: 'The note ',
        skills: 'React, Node.js, Bootstrap, JS',
        img: project2,
        imgBig: project2,
        gitHubLink: '#'
    },

    {
        title: 'Currency exchange',
        skills: 'React, Node.js, Bootstrap, JS',
        img: project3,
        imgBig: project3,
        gitHubLink: '#'
    },
];

export {projects}